import { IModalProps, ModalContext } from 'context/ModalContext'
import { useContextSelector } from 'use-context-selector'

const useModal = (): IModalProps => {
  const showModal = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.showModal
  )
  const closeModal = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.closeModal
  )
  const showConnectionLostModal = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.showConnectionLostModal
  )
  const visible = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.visible
  )

  const handleCancel = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.handleCancel
  )

  const handleConfirm = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.handleConfirm
  )

  const handleThird = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.handleThird
  )

  const hideButtonCancel = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.hideButtonCancel
  )

  const message = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.message
  )

  const titleModal = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.titleModal
  )

  const txtButtonCancel = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.txtButtonCancel
  )

  const txtButtonConfirm = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.txtButtonConfirm
  )

  const type = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.type
  )

  const typeButtonCancel = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.typeButtonCancel
  )

  const typeButtonConfirm = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.typeButtonConfirm
  )

  const hideButtonConfirm = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.hideButtonConfirm
  )
  const hideThirdButton = useContextSelector(
    ModalContext,
    (state: IModalProps) => state.hideThirdButton
  )

  return {
    showConnectionLostModal,
    closeModal,
    handleCancel,
    handleConfirm,
    handleThird,
    hideButtonCancel,
    hideButtonConfirm,
    hideThirdButton,
    message,
    showModal,
    titleModal,
    txtButtonCancel,
    txtButtonConfirm,
    type,
    typeButtonCancel,
    typeButtonConfirm,
    visible
  }
}

export default useModal
